import React from 'react'
import Header from '../../component/Header'
import Footer from '../../component/Footer'
import Certification from '../Certification'

export default function LayoutCertification() {
    return (
        <div>
            <Header />
            <Certification />
            <Footer />
        </div>
    )
}
